import { useFormikContext } from 'formik'
import React, { useMemo } from 'react'
import { GetCallerInfoResponse } from 'shared/api/crm/ApiGlobals'
import ManagerApi from 'shared/api/manager/Api'
import FetchData from 'shared/components/FetchData'
import {
  Avatar1,
  Avatar2,
  Avatar3,
  Avatar4,
} from 'shared/components/icon-pack/icons'

import { formikValuesType } from '../../index'
import { ContactInfo } from './ContactInfo'
import { ContactInfoForm } from './ContactInfoForm'
import SidebarBg from './SidebarBg'

const profileClassName = 'w-[82px] h-[82px] rounded-full -translate-y-[50px]'

const allSvg = [
  <Avatar1 className={profileClassName} />,
  <Avatar2 className={profileClassName} />,
  <Avatar3 className={profileClassName} />,
]

function ContactInfoCard() {
  const { values } = useFormikContext<formikValuesType>()
  const randomIndex = useMemo(
    () => Math.floor(Math.random() * allSvg.length),
    []
  )

  const fetchCustomerData = async () => {
    // return CrmApi.customer
    //   .customersGetCustomerData({
    //     id: values?.lead?.id,
    //     type: values?.lead?.type,
    //   })
    //   .then((res) => res.data)
    if (values?.lead?.id)
      return ManagerApi?.salesPersons
        ?.getClientDataDetail(values?.lead?.id)
        .then((res) => {
          return res.data
        })
    return null
  }

  const parseProfile = useMemo(() => {
    const preName = values?.preName?.label

    if (preName === 'خانم') {
      return <Avatar4 className={profileClassName} />
    } else {
      return allSvg[randomIndex]
    }
  }, [randomIndex, values?.preName?.label])

  return (
    <div className="w-[100%] rounded-lg bg-white h-[100%] overflow-hidden ">
      <SidebarBg className={'w-full h-[174px] rounded-t-3 '} />

      <div className={'w-full flex justify-center'}>{parseProfile}</div>
      {values?.lead?.type === 'contact' || values?.lead?.type === 'account' ? (
        <FetchData request={fetchCustomerData} deps={[values.lead?.id]}>
          {(data: GetCallerInfoResponse) => {
            if (!data) return null
            return <ContactInfo {...data} />
          }}
        </FetchData>
      ) : (
        <ContactInfoForm />
      )}
    </div>
  )
}

export default ContactInfoCard
